export const RemoveIcon = (props) => {
  const handler = () => {
    props.clickAction();
  };
  return (
    <div
      onClick={() => handler()}
      className="rounded-full border-2 border-primary flex items-center justify-center h-8 w-8 hover:bg-primary group cursor-pointer"
    >
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="1.15824"
          y1="0.669922"
          x2="15.6181"
          y2="15.1298"
          className="stroke-primary group-hover:stroke-white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="1.34672"
          y1="0.856445"
          x2="15.8065"
          y2="15.3163"
          className="stroke-primary group-hover:stroke-white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="15.8066"
          y1="1.21"
          x2="1.34681"
          y2="15.6698"
          className="stroke-primary group-hover:stroke-white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
